// Full screen view with the pikachoo header on top
import React from 'react'

import styles from './ScrollingBody.module.scss'

export const ScrollingBody = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.scrollingBody}>{children}</div>
)
